// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__17cXd","productName":"Table_productName__1zs0z"};